import { Message } from 'primereact/message';
export const Nodatacomp = () =>{
   return(
    <h3>No data</h3>
   );
}


export const Nodataprimecomp = () =>{
   return(
      <Message severity="info" text="No data found" />
   );
}


